import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const api = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

// Request interceptor to add authorization token from localStorage
api.interceptors.request.use(
  (config) => {
    // Prefer partner token if present, otherwise fall back to session token
    const partnerToken = localStorage.getItem("partnerToken");
    const sessionToken = localStorage.getItem("sessionToken");

    if (partnerToken) {
      config.headers.Authorization = `Bearer ${partnerToken}`;
      console.log("[API] Added Authorization header to request:", config.url);
    } else if (sessionToken) {
      config.headers.Authorization = `Bearer ${sessionToken}`;
      console.log("[API] Added session Authorization header to request:", config.url);
    } else {
      console.log("[API] No partner token found for request:", config.url);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Redirect to login on 401 and preserve the current path for post-login return
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401) {
      const path = window.location.pathname;
      const isPublicQR = path.startsWith("/qr/") && !path.startsWith("/qr/generator");
      const isPublicPartnerFeedback = path.startsWith("/partner-feedback");
      const isLogin = path === "/login" || path === "/auth/success";
      
      if (!isPublicQR && !isPublicPartnerFeedback && !isLogin) {
        // Clear any auth tokens so we don't bounce between dashboard and login
        try {
          localStorage.removeItem("partnerToken");
          localStorage.removeItem("partnerUser");
          localStorage.removeItem("sessionToken");
        } catch (_) {}
        delete api.defaults.headers.common["Authorization"];

        try {
          const redirectTo = window.location.pathname + window.location.search + window.location.hash;
          localStorage.setItem("postLoginRedirect", redirectTo);
        } catch (_) {}
        window.location.assign("/login");
      } else {
        console.log("[API INTERCEPTOR] ✅ Public path - NOT redirecting");
      }
    }
    return Promise.reject(error);
  }
);

export default api;
